import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../common/CmnContext';

export function SaleListNoData() {
  const isPc = useContext(cmnContext).isPc;

  return (
    <div style={{
      paddingTop: 30,
      paddingBottom: window.innerHeight * 0.1,
    }}>
      <p style={{
        fontSize: isPc? '150%' : '120%',
        fontWeight: 'bold',
        textAlign: 'center',
      }}>動画が見つかりませんでした</p>
    </div>
  );
}